import GamesTimerBadge from "../../badges/games/GamesTimerBadge";

export default function GamesInComingMessage() {
    // Used in GamesScreenContent to display info message
    // about games in coming

    // BUILD
    return (
        <div className={"bg-notifRed/10 w-full flex space-x-[12px] rounded-[16px] px-[10px] py-[10px] mt-[24px] mb-[48px]"}>
            <GamesTimerBadge />
            <div className={"flex flex-col space-y-[4px] justify-start items-start"}>
                <span className={"font-medium text-white text-[16px] leading-tight"}>
                    {"D'autres jeux arrivent bientôt !"}
                </span>
                <span className={"font-normal text-greyLight9 text-[14px]"}>
                    {"Nous travaillons sur de nouveaux mini-jeux pour rendre l'apprentissage encore plus amusant. Reste connecté pour découvrir les prochaines nouveautés !"}
                </span>
            </div>
        </div>
    );
}